<script setup>
  import CreateInventaire from '@/components/CreateInventaire.vue'

</script>

<template>
  <h1>Inventaire</h1>
  <div class="home">
    <CreateInventaire/>
  </div>
</template>

<script>


export default {

}
</script>

<style>


</style>
